(() => {
  const readPurchaseSection = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    if (holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-purchase-section", "");
  };

  const readHpValueProps = () => {
    const hpValueProps = window._growthbook.getFeatureValue(
      "pdm-homepage-value-props",
      false,
    );
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    console.log("pdm homepage value props", hpValueProps, holdoutGroup);

    if (!hpValueProps || holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-homepage-value-props", "");
  };

  const readSubscribeAndSave = () => {
    const subscribeAndSave = window._growthbook.getFeatureValue(
      "pdm-subscribe-and-save",
      false,
    );
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    console.log("pdm subscribe and save", subscribeAndSave, holdoutGroup);

    if (!subscribeAndSave || holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-subscribe-and-save", "");
  };

  const readProductCardsSlider = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    if (holdoutGroup === holdoutValue) {
      return;
    }

    document.querySelectorAll(".pdm-hover-image").forEach((el) => {
      const parent = el.parentElement;
      parent
        .querySelector(".card__media .media img")
        .insertAdjacentElement("afterend", el);
    });

    document.body.setAttribute("data-product-cards-slider", "");
  };

  const readHomeCategory = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    if (holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-home-category", "");
  };

  const readBestSellerMenu = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    if (holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-best-sellers-menu", "");
    (function () {
      function insertBestSeller(anchorId, newId, classes, isSpan) {
        const shopAll = document.getElementById(anchorId);
        if (!shopAll) return;

        if (document.getElementById(newId)) return;

        const li = document.createElement("li");
        const a = document.createElement("a");

        a.id = newId;
        a.href = "/collections/best-sellers";
        a.className = classes;

        if (isSpan) {
          const span = document.createElement("span");
          span.textContent = "Best Sellers";
          a.appendChild(span);
        } else {
          a.textContent = "Best Sellers";
        }

        li.appendChild(a);
        shopAll.parentElement.insertAdjacentElement("afterend", li);
      }

      function run() {
        // Desktop menu
        insertBestSeller(
          "HeaderMenu-shop-all",
          "HeaderMenu-best-seller",
          "header__menu-item list-menu__item link link--text focus-inset",
          true,
        );

        // Drawer / mobile menu
        insertBestSeller(
          "HeaderDrawer-shop-all",
          "HeaderDrawer-best-seller",
          "menu-drawer__menu-item list-menu__item link link--text focus-inset",
          false,
        );
      }

      // Run on load
      document.addEventListener("DOMContentLoaded", run);

      run();
    })();
  };

  const readBenefitCollapsePDP = () => {
    const homeCategorySlider = window._growthbook.getFeatureValue(
      "pdm-benefit-highlights",
      false,
    );

    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    if (!homeCategorySlider || holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-collapse-pdp", "");

    (function () {
      function initReadMore() {
        const els = document.querySelectorAll(".read-more-product");

        els.forEach((el) => {
          if (el.dataset.rmInit) return;
          el.dataset.rmInit = "1";

          const fullText = el.innerHTML;

          // Contenedor del texto
          const textWrap = document.createElement("div");
          textWrap.innerHTML = fullText;

          // Estilos inline (JS only)
          textWrap.style.display = "-webkit-box";
          textWrap.style.webkitBoxOrient = "vertical";
          textWrap.style.webkitLineClamp = "2";
          textWrap.style.overflow = "hidden";

          // Botón Read more
          const toggle = document.createElement("span");
          toggle.textContent = "Read more";
          toggle.classList = "read-more";
          toggle.style.display = "block"; // fuerza tercera línea
          toggle.style.marginTop = "4px";
          toggle.style.cursor = "pointer";
          toggle.style.fontStyle = "italic";
          toggle.style.color = "#FF47C2";
          toggle.style.fontFamily = "'GTAlpina-Italic', sans-serif";
          toggle.style.fontSize = "24px";
          toggle.style.fontWeight = "300";

          let open = false;

          toggle.addEventListener("click", () => {
            open = !open;

            if (open) {
              textWrap.style.webkitLineClamp = "unset";
              toggle.textContent = "Read less";
            } else {
              textWrap.style.webkitLineClamp = "2";
              toggle.textContent = "Read more";
            }
          });

          el.innerHTML = "";
          el.appendChild(textWrap);
          el.appendChild(toggle);
        });
      }

      initReadMore();
      document.addEventListener("shopify:section:load", initReadMore);
    })();
  };

  const readPlpOptimizedMobileGrid = () => {
    const subscribeAndSave = window._growthbook.getFeatureValue(
      "pdm-plp-optimized-mobile-grid",
      false,
    );
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    console.log(
      "pdm plp optimized mobile grid",
      subscribeAndSave,
      holdoutGroup,
    );

    if (!subscribeAndSave || holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-plp-optimized-mobile-grid", "");
  };

  const readStickyAtcFix = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
      "OFF",
    );

    if (holdoutGroup === "holdout-q1-2026") {
      document.body.setAttribute("data-sticky-atc-fix", "true");
      return;
    } else {
      document.body.setAttribute("data-sticky-atc-fix", "false");
    }
  };

  const readMobileVisualNav = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    const holdoutValue = "holdout-q1-2026";

    console.log("pdm mobile visual nav", holdoutGroup);

    if (holdoutGroup === holdoutValue) {
      return;
    }

    document.body.setAttribute("data-pdm-mobile-visual-nav", "");
  };

  const otpComparedAtPrice = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
    );
    if (holdoutGroup !== "OFF") {
      document.body.setAttribute("data-otp-compared-at-price", "false");
    }
  };

  const goodBetterBest = () => {
    const isGoodBetterBest = window._growthbook.getFeatureValue(
      "pdm-good-better-best-v2",
      false,
    );

    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
      "OFF",
    );

    if (isGoodBetterBest && holdoutGroup != "holdout-q2-2026") {
      document.body.setAttribute("data-good-better-best", "true");
    }
  };

  const cartValueProps = () => {

    const holdoutGroup = window._growthbook.getFeatureValue(
      "holdout-pdm-belli-welli",
      "OFF",
    );

    if (holdoutGroup != "holdout-q2-2026") {
      function addValueProps(el) {
        const target = el.querySelector(".rebuy-cart__flyout");
        const footer = document.querySelector(
          "[data-rebuy-cart-anchor='footer']",
        );

        if (!target) return;

        // 🚩 FLAG: prevent multiple appends
        if (target.dataset.valuePropsAppended === "true") {
          return;
        }

        footer?.style.setProperty("padding-bottom", "0px", "important");

        const valueProps = document.getElementById("cart-value-props");

        if (!valueProps) return;

        console.log("adding value props to:", target);

        target.appendChild(valueProps.content.cloneNode(true));

        // set flag
        target.dataset.valuePropsAppended = "true";
      }

      const waitForRebuyCart = () => {
        const el = document.getElementById("rebuy-cart");

        if (el) {
          addValueProps(el);
          return;
        }

        const observer = new MutationObserver(() => {
          const el = document.getElementById("rebuy-cart");
          if (el) {
            observer.disconnect();
            addValueProps(el);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      };

      waitForRebuyCart();
    }
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      readPurchaseSection();
      readProductCardsSlider();
      readSubscribeAndSave();
      readHomeCategory();
      readHpValueProps();
      readBestSellerMenu();
      readBenefitCollapsePDP();
      readPlpOptimizedMobileGrid();
      readStickyAtcFix();
      readMobileVisualNav();
      goodBetterBest();
      otpComparedAtPrice();
      cartValueProps();
    };

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
